export class ActualizarColeccionista {
    nombre: string;
    correoElectronico: string;
    telefono: string;
}